import { render, staticRenderFns } from "./LoanCollateralAssetTradeReceivablesFieldsDisplay.vue?vue&type=template&id=76529082&scoped=true&lang=pug&"
import script from "./LoanCollateralAssetTradeReceivablesFieldsDisplay.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralAssetTradeReceivablesFieldsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LoanCollateralAssetTradeReceivablesFieldsDisplay.vue?vue&type=style&index=0&id=76529082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76529082",
  null
  
)

/* custom blocks */
import block0 from "./LoanCollateralAssetTradeReceivablesFieldsDisplay.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports